

import Module from 'mdui/page/Module';
import MCModule from 'mdui/page/MCModule';
import Warmboot from 'mdui/page/Warmboot';
import AdmConsole from 'core/pages/AdmConsole';
import consoleJob from 'core/pages/ViewBatchJobs';

export const Pages = {
    '*': {page: Module},
    'MC': {page: MCModule},
    'Warmboot': {page: Warmboot},
    'AdmConsole': {page: AdmConsole},
    'consoleJob': {page: consoleJob},
}